import { useDebounce, useGetPlaces } from "@api";
import type { IPlace } from "@bbj-types/address";
import { useCallback, useMemo } from "react";

export interface IPlacesQuery {
  search: string;
  _id?: string[];
}

export const useAutocompletePlaces = (query?: IPlacesQuery) => {
  const [{ loading, data }, getPlaces] = useGetPlaces();

  const loadOnOpen = useCallback(() => {
    if (query) {
      void getPlaces({ ...query });
    }
  }, [getPlaces, query]);

  const getDebouncePlaces = useDebounce(
    (newInputValue: string) => {
      if (newInputValue.length) {
        void getPlaces({ search: newInputValue });
      }
    },
    1000,
    [getPlaces]
  );
  const options = useMemo<IPlace[]>(() => data?.data ?? [], [data?.data]);

  return { loading, getDebouncePlaces, options, loadOnOpen };
};
